module.exports = __webpack_public_path__ + "static/media/image-gallery-8.f2bc6b94.jpg";